module.exports = {
    passwordRegex: new RegExp('.{6,}')
};
